var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyInline = function SvgCopyInline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54736 12.4453H2.71191C1.7891 12.4453 1.04102 11.6972 1.04102 10.7744V3.25537C1.04102 2.33256 1.7891 1.58447 2.71191 1.58447H10.231C11.1538 1.58447 11.9019 2.33256 11.9019 3.25537V4.09082M8.56006 18.2935H16.0791C17.0019 18.2935 17.75 17.5454 17.75 16.6226V9.10352C17.75 8.1807 17.0019 7.43262 16.0791 7.43262H8.56006C7.63725 7.43262 6.88916 8.1807 6.88916 9.10352V16.6226C6.88916 17.5454 7.63725 18.2935 8.56006 18.2935Z",
    stroke: "current",
    strokeWidth: 1.6709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyInline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-inline.eaff947c840077c30aee0b704edf6490.svg";